import { render, staticRenderFns } from "./SubscriptionList.vue?vue&type=template&id=3488c764&scoped=true&"
import script from "./SubscriptionList.vue?vue&type=script&lang=js&"
export * from "./SubscriptionList.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionList.vue?vue&type=style&index=0&id=3488c764&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3488c764",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
